import config from '../../config';
import styles from './Breadcrumb.module.scss';

function Breadcrumb({ categories, chosen, lang, hideAll, isProductCategory }) {
  const isEnglish = lang === 'en';
  const basePath = config.basePath || '/';

  return (
    <ul className={styles.breadcrumb}>
      {!hideAll && (
        <li>
          <a href={basePath}>
            {isEnglish ? 'All' : '全部'}
          </a>
        </li>
      )}

      {Array.isArray(categories) && categories.map((cat, idx) => {
        const catName = isEnglish ? cat.nameEN : cat.nameTC;
        return (
          <li key={idx}>
            {
              catName === chosen ? (
                catName
              ) : (
                <a href={`${basePath}/product-category/?${isProductCategory ? 'pid' : 'id'}=${cat.documentId}`}>
                  {catName}
                </a>
              )
            }
          </li>
        );
      })
      }

      {
        !Array.isArray(categories) && categories && (
          <>
            <li>
              <a href={`${basePath}/product-category/?id=${categories.documentId}`}>
                {isEnglish ? categories.nameEN : categories.nameTC}
              </a>
            </li>
            <li>Current Product</li>
          </>
        )
      }
    </ul>
  );
}

export default Breadcrumb;
